import { FilterSearchingBaseViewModel, PagingResultsViewModel } from 'src/app/components/core/_infrastructure/types/common';

export class TcComunidadAutonomaViewModel {
    public Id: number;
    public Descripcion: string;
    public Email: string;
}

export class ComunidadAutonomaItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: TcComunidadAutonomaItemViewModel[];
}

export class TcComunidadAutonomaItemViewModel {
    public Id: number;
    public Descripcion: string;
    public Email: string;
}

export class FilterSearchingTcComunidadAutonomaViewModel extends FilterSearchingBaseViewModel {
    public Id: number;
    public Descripcion: string;
    public Email: string;
}
